module.exports = __webpack_public_path__ + "img/subscription.4716cc3e.png";